// Mock data for Centro Oftalmológico Santa Lucía
// NOTE: This is MOCK data used for the frontend-only build.

export const clinic = {
  name: "Centro Oftalmológico",
  brand: "Santa Lucía",
  tagline: "Tu visión es nuestra prioridad",
  city: "San Fernando",
  region: "Región de O'Higgins",
  country: "Chile",
  address: "Negrete 1374, San Fernando, Región de O'Higgins, Chile",
  addressNote: "Frente al Hospital de San Fernando",
  callCenter: "+56 2 3377 2019",
  callCenterTel: "+56233772019",
  whatsapp: "+56 9 5871 4449",
  whatsappLink: "https://wa.me/56958714449",
  email: "reserva@ceoslucia.cl",
  instagram: "https://www.instagram.com/ceoslucia.cl",
  instagramHandle: "@ceoslucia.cl",
  panelUrl: "https://panel.ceoslucia.cl/login",
  bookingUrl: "https://www.imagensalud.cl/equipo/kael-aldazoro",
  luciaUrl: "https://ia.ceoslucia.cl/chat?source=web-ceoslucia",
  luciaApiUrl: "https://ceo-santa-lucia.emergent.host/api/chat",
  partner: { name: "Imagen Salud", url: "https://www.imagensalud.cl/" },
  logoSantaLucia: "/assets/brand/logo-santalucia.jpg",
  logoImagenSalud: "/assets/brand/logo-imagensalud.png",
  qrLucia: "/assets/brand/qr-lucia-chat.png",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Negrete%201374%20San%20Fernando%20Chile&destination_place_id=ChIJy8CG8h6RZJYRY0S1U3PhgDY",
  parkingNote:
    "Estacionamiento pagado disponible justo al lado, en Imagen Salud.",
  mapEmbed:
    "https://www.google.com/maps?q=Negrete%201374%20San%20Fernando%20Chile&output=embed",
  hours: [
    { day: "Lunes a Viernes", time: "08:40 – 19:00" },
    { day: "Sábado", time: "09:00 – 13:00" },
    { day: "Domingo", time: "Cerrado" },
  ],
};

export const heroImages = {
  eyeMacro: "https://images.unsplash.com/photo-1501621667575-af81f1f0bacc",
  eyeMacro2: "https://images.unsplash.com/photo-1516220362602-dba5272034e7",
};

export const stats = [
  { value: "+3.191", label: "Cirugías exitosas" },
  { value: "+12.200", label: "Atenciones médicas" },
  { value: "24/7", label: "Orientación LucIA" },
];

export const insurances = [
  {
    title: "Atención con FONASA",
    desc: "Valor preferencial en consulta oftalmológica en San Fernando.",
  },
  {
    title: "Reembolsable con ISAPRE",
    desc: "Consultas, exámenes y cirugías con respaldo de bono e informes.",
  },
  {
    title: "Especialistas de referencia",
    desc: "Retina · Cataratas · Glaucoma con tecnología de última generación.",
  },
];

export const services = [
  {
    id: "refractiva",
    icon: "Eye",
    title: "Cirugía Refractiva y de Catarata",
    short: "Corrección definitiva de miopía, astigmatismo e hipermetropía.",
    desc: "Somos especialistas en la corrección definitiva de Miopía, Astigmatismo e Hipermetropía mediante Cirugía Facorefractiva. Además, tratamos la Catarata (opacidad del cristalino) con procedimientos avanzados para restaurar la nitidez, permitiéndole dejar atrás la dependencia de las lentes.",
    tags: ["Facorefractiva", "Catarata", "Lente intraocular"],
  },
  {
    id: "retina",
    icon: "ScanEye",
    title: "Tratamiento de Retina y Mácula",
    short: "Diagnóstico y tratamiento de enfermedades de la visión central.",
    desc: "Nuestra área se enfoca en el diagnóstico y tratamiento de enfermedades que amenazan su visión central y de detalle. Atendemos patologías como Oclusiones vasculares, Miopía alta Magna, Degeneración Macular (DMRE), Retinopatía Diabética y Edema Macular, utilizando tecnología de precisión para proteger sus funciones vitales a largo plazo.",
    tags: ["DMRE", "Retinopatía diabética", "Edema macular"],
  },
  {
    id: "glaucoma",
    icon: "Activity",
    title: "Manejo Avanzado del Glaucoma",
    short: "Control de precisión de la presión ocular con tecnología láser.",
    desc: "Ofrecemos un manejo de precisión para el Glaucoma, enfermedad que daña el nervio óptico. Utilizamos tecnología láser y cirugía especializada para controlar la presión ocular y evitar la progresión de la pérdida de visión, con un seguimiento constante y personalizado.",
    tags: ["Presión ocular", "Láser", "Seguimiento"],
  },
  {
    id: "ojo-seco",
    icon: "Droplet",
    title: "Unidad Integral de Ojo Seco",
    short: "Soluciones definitivas para el ojo seco y la superficie ocular.",
    desc: "Soluciones definitivas para el Ojo Seco (Evaporativo o Acuoso) y el malestar crónico. En lugar de solo aliviar los síntomas, actuamos en la raíz del problema. Implementamos terapias de Láser y Luz Pulsada (OPE + LLLT) para regenerar la superficie ocular y eliminar la dependencia constante de gotas.",
    tags: ["OPE / IPL", "LLLT", "Superficie ocular"],
  },
  {
    id: "parpados",
    icon: "Scissors",
    title: "Cirugía Estética y Funcional de Párpados",
    short: "Manejo médico y quirúrgico de los párpados.",
    desc: "Realizamos el manejo médico y quirúrgico de los párpados. Corregimos problemas funcionales como Párpado Caído (Ptosis), Entropión y Ectropión, y tratamos la Blefarochalasis (exceso de piel) para mejorar tanto la visión como la apariencia de la mirada, logrando resultados naturales.",
    tags: ["Ptosis", "Blefaroplastia", "Entropión"],
  },
  {
    id: "dermatologia",
    icon: "Sparkles",
    title: "Dermatología Estética Facial",
    short: "Cuidado integral de la piel del rostro y periocular.",
    desc: "Nuestra experiencia se extiende al cuidado integral de la piel del rostro. Diagnosticamos y tratamos afecciones comunes como Rosácea, Acné, Manchas Solares y lesiones cutáneas en los párpados, con el fin de mejorar la textura, uniformidad y salud general de su piel.",
    tags: ["Rosácea", "Rejuvenecimiento", "Antienvejecimiento"],
  },
];

export const technologies = [
  {
    name: "Equipo IDRA",
    subtitle: "Diagnóstico integral del Ojo Seco",
    desc: "Analizador de superficie ocular de última generación que evalúa la película lagrimal, glándulas de Meibomio y calidad lagrimal para un diagnóstico preciso del ojo seco.",
    icon: "Microscope",
  },
  {
    name: "Equipo Eyelight",
    subtitle: "Luz Pulsada OPE (IPL) + Láser MT-LLLT",
    desc: "Trabaja con la última generación de luz pulsada OPE (IPL) y luz modulada láser MT-LLLT (roja, azul y amarilla). Terapia antienvejecimiento y rejuvenecimiento periocular y facial.",
    icon: "Zap",
  },
];

export const doctor = {
  name: "Dr. Kael Aldazoro Romero",
  role: "Médico Oftalmólogo",
  subspecialty: "Subespecialidad en Retina y Vítreo",
  university: "Universidad Central de Venezuela (UCV)",
  position: "Jefe de Oftalmología del Hospital de San Fernando, Región de O'Higgins",
  bio: "Médico Oftalmólogo egresado de la Universidad Central de Venezuela (UCV), con subespecialidad en retina y vítreo y amplia experiencia en cirugía de catarata y facorefractiva. Con más de 6 años de práctica en Chile, ha realizado más de 12.200 atenciones médicas y más de 3.190 cirugías.",
  philosophy:
    "Ofrecer una atención de excelencia, cercana, respaldada por la mayor tecnología de punta para lograr resultados efectivos.",
  achievements: ["+3.190 cirugías realizadas", "+12.200 atenciones médicas", "+6 años de práctica en Chile"],
  image: "/assets/gallery/dr_kael.webp",
  video: "/assets/media/dr_presentacion.mp4",
};

export const exams = [
  "Tomografía de Coherencia Óptica (OCT) de retina y nervio óptico",
  "Retinografía Digital de Alta Resolución",
  "Campo Visual Computarizado",
  "Topografía Corneal y Pupilometría",
  "Diagnóstico Robótico de Ojo Seco (Plataforma IDRA)",
  "Test de Schirmer",
];

export const procedures = [
  {
    unit: "Unidad de Retina",
    icon: "ScanEye",
    items: ["Inyección de Anti-VEGF", "Láser Argón", "Tratamiento de desgarros retinianos"],
  },
  {
    unit: "Unidad de Glaucoma",
    icon: "Activity",
    items: ["Iridotomía láser", "Trabeculoplastia SLT", "Capsulotomía YAG"],
  },
  {
    unit: "Unidad de Ojo Seco Avanzado",
    icon: "Zap",
    items: ["Tecnología Eye-Light (IPL + LLLT)", "Manejo de Rosácea Ocular", "Regeneración de superficie ocular"],
  },
];

export const otherConditions = [
  "Pterigión (carnosidad)",
  "Orzuelo",
  "Blefaritis Crónica",
  "Ojo Rojo Crónico",
];

export const bookingSteps = [
  "Presiona “Reservar Hora” e ingresa tu RUT. Si es tu primera visita, regístrate para crear tu ficha digital.",
  "Elige la sucursal Negrete 1374 y presiona “Siguiente”.",
  "Selecciona el día y horario que más te acomode.",
  "Acepta los términos y condiciones y confirma tu reserva.",
];

export const galleryImages = {
  clinic: "https://images.pexels.com/photos/33857823/pexels-photo-33857823.jpeg",
  clinic2: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d",
  exam1: "https://images.pexels.com/photos/6749706/pexels-photo-6749706.jpeg",
  exam2: "https://images.pexels.com/photos/6749738/pexels-photo-6749738.jpeg",
};

export const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Especialidades", href: "#especialidades" },
  { label: "Tecnología", href: "#tecnologia" },
  { label: "El Médico", href: "#medico" },
  { label: "Opiniones", href: "#opiniones" },
  { label: "Contacto", href: "#contacto" },
];

export const galleryItems = [
  {
    type: "video",
    src: "/assets/media/cirugia.mp4",
    poster: "/assets/gallery/luxor.webp",
    title: "Cirugía de catarata en vivo",
    caption: "Dr. Aldazoro operando con visualización de última generación",
  },
  {
    src: "/assets/gallery/luxor.webp",
    title: "Microscopio quirúrgico LuxOR Revalia",
    caption: "Cirugía de catarata con Centurion Vision System",
  },
  {
    src: "/assets/gallery/topcon.webp",
    title: "Unidad de Consulta Topcon",
    caption: "La estación de diagnóstico más completa para la consulta",
  },
  {
    src: "/assets/gallery/idra.webp",
    title: "Plataforma IDRA",
    caption: "Diagnóstico robótico del ojo seco",
  },
  {
    src: "/assets/gallery/eyelight.webp",
    title: "Equipo Eye-Light",
    caption: "Luz pulsada OPE (IPL) + láser MT-LLLT",
  },
  {
    src: "/assets/gallery/redmask.webp",
    title: "Terapia MT-LLLT · Luz roja",
    caption: "Rejuvenecimiento periocular y facial antienvejecimiento",
  },
  {
    src: "/assets/gallery/henson.webp",
    title: "Campímetro Henson 9000",
    caption: "Campo visual computarizado",
  },
  {
    src: "/assets/gallery/triton.webp",
    title: "Tomografía OCT · Topcon DRI OCT Triton",
    caption: "Diagnóstico profundo de retina y nervio óptico",
  },
  {
    src: "/assets/gallery/retinografo.webp",
    title: "Retinógrafo DRS CenterVue",
    caption: "Retinografía digital de alta resolución",
  },
  {
    src: "/assets/gallery/topografo.webp",
    title: "Topógrafo Corneal CA-800",
    caption: "Análisis de la córnea y superficie ocular",
  },
];

// Ejemplos reales de resultados de exámenes
export const examImages = [
  {
    src: "/assets/gallery/octa.webp",
    title: "Angiografía OCT (OCT-A) sin contraste",
    caption: "Estudio vascular de la retina, seguro y sin colorante para todos",
  },
  {
    src: "/assets/gallery/retino.webp",
    title: "Retinografía de campo amplio",
    caption: "Visualización panorámica del fondo de ojo",
  },
];

// NOTE: Testimonios MOCK con formato de reseñas de Google.
// Se conectarán en vivo a Google Places cuando se disponga del Place ID + API Key.
export const testimonials = [
  {
    name: "María Fernanda Rojas",
    initial: "M",
    rating: 5,
    date: "Hace 2 semanas",
    text: "Excelente atención del Dr. Aldazoro. Me operé de cataratas y el resultado fue increíble. Todo el equipo muy profesional y la tecnología de primer nivel.",
  },
  {
    name: "Jorge Contreras",
    initial: "J",
    rating: 5,
    date: "Hace 1 mes",
    text: "El mejor centro oftalmológico de San Fernando. Me trataron el ojo seco con el equipo Eyelight y noté la mejoría de inmediato. 100% recomendado.",
  },
  {
    name: "Carolina Muñoz",
    initial: "C",
    rating: 5,
    date: "Hace 1 mes",
    text: "Muy buena experiencia. Reserva fácil, atención puntual y un doctor que explica todo con paciencia. Se nota que es un centro especializado.",
  },
  {
    name: "Luis Herrera",
    initial: "L",
    rating: 5,
    date: "Hace 2 meses",
    text: "Me realizaron exámenes de retina con equipos de última generación. Diagnóstico claro y tratamiento oportuno. Gracias al equipo por la dedicación.",
  },
  {
    name: "Patricia Salinas",
    initial: "P",
    rating: 5,
    date: "Hace 3 meses",
    text: "Atención humana y cercana. El Dr. Kael es un excelente profesional y las instalaciones son impecables. Volveré sin dudarlo.",
  },
  {
    name: "Rodrigo Vega",
    initial: "R",
    rating: 4,
    date: "Hace 3 meses",
    text: "Muy conforme con el control de mi glaucoma. Seguimiento constante y tecnología láser de primer nivel. Recomendado para la zona.",
  },
];

export const reviewSummary = { rating: 4.9, count: 187 };

export const luciaFeatures = [
  { icon: "MessageSquareHeart", title: "Chat con IA", desc: "Conversa con LucIA sobre patologías oculares 24/7." },
  { icon: "FileText", title: "Tu informe médico", desc: "Accede a tus resultados y tareas pendientes." },
  { icon: "ClipboardCheck", title: "Test rápido", desc: "“El Ojo es Copuchento”: evalúa tus síntomas en 5 min." },
  { icon: "ShieldCheck", title: "Seguro y privado", desc: "Cumple la Ley 19.628 de protección de datos." },
];
